import { render, staticRenderFns } from "./Artists.vue?vue&type=template&id=02c86561&scoped=true"
import script from "./Artists.vue?vue&type=script&lang=ts"
export * from "./Artists.vue?vue&type=script&lang=ts"
import style0 from "./Artists.vue?vue&type=style&index=0&id=02c86561&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c86561",
  null
  
)

export default component.exports